import React from "react";
import SeoArticlePage from "../../components/SeoArticlePage";

export default function RevisionLoyerIrl() {
  return (
    <SeoArticlePage
      seo={{
        title: "Révision de loyer avec l'IRL : calcul, formule et exemple | 360immoinvest",
        description:
          "Comment réviser un loyer avec l'indice de référence des loyers (IRL) ? Conditions, formule de calcul, exemple chiffré et révision automatique avec 360immoinvest.",
        path: "/revision-loyer-irl",
        testid: "seo-irl-page",
      }}
      eyebrow="Guide du bailleur"
      h1="Réviser un loyer avec l'indice de référence des loyers (IRL)"
      intro="Chaque année, vous pouvez réviser le loyer de votre location en fonction de l'IRL publié par l'Insee. 360immoinvest récupère le bon indice et calcule automatiquement le nouveau loyer, dans les règles."
      sections={[
        {
          title: "Qu'est-ce que l'IRL ?",
          paragraphs: [
            "L'indice de référence des loyers (IRL) est un indice publié chaque trimestre par l'Insee. Il sert de base légale à la révision annuelle des loyers d'habitation. Il évolue en fonction de l'inflation, ce qui encadre la hausse possible du loyer.",
          ],
        },
        {
          title: "À quelles conditions peut-on réviser le loyer ?",
          paragraphs: ["La révision annuelle n'est possible que si certaines conditions sont réunies :"],
          bullets: [
            "Le bail contient une clause de révision annuelle du loyer",
            "La révision intervient à la date prévue au bail (date anniversaire ou date indiquée)",
            "Le logement respecte ses obligations (notamment de performance énergétique pour les passoires thermiques)",
            "Le bailleur applique la révision dans le délai d'un an, faute de quoi elle est perdue pour l'année écoulée",
          ],
        },
        {
          title: "La formule de calcul",
          paragraphs: [
            "Le nouveau loyer se calcule ainsi : Nouveau loyer = Loyer en cours × (IRL du trimestre de référence / IRL du même trimestre de l'année précédente).",
            "Le trimestre de référence est celui indiqué dans le bail ; à défaut, c'est le dernier indice publié à la date de signature.",
          ],
        },
        {
          title: "Exemple chiffré",
          paragraphs: [
            "Loyer actuel de 800 €. IRL de référence de l'année en cours : 145,17. IRL du même trimestre l'année précédente : 140,59.",
            "Nouveau loyer = 800 × (145,17 / 140,59) = 826,06 €, soit une hausse d'environ 26 € par mois.",
          ],
        },
        {
          title: "La révision automatique avec 360immoinvest",
          paragraphs: [
            "L'application récupère les indices IRL à jour, applique la formule pour vous et vous propose le nouveau loyer à la date de révision. Vous générez ensuite le courrier d'information au locataire et l'ajustement est reporté sur vos quittances.",
          ],
        },
      ]}
      faq={[
        { q: "À quelle fréquence peut-on réviser le loyer ?", a: "Une fois par an, à la date prévue dans le bail, à condition qu'une clause de révision y figure." },
        { q: "Que se passe-t-il si j'oublie de réviser ?", a: "La révision doit être appliquée dans un délai d'un an. Passé ce délai, la hausse de l'année écoulée est perdue, mais vous pouvez réviser l'année suivante." },
        { q: "Où trouver le bon indice IRL ?", a: "Les indices sont publiés par l'Insee chaque trimestre. 360immoinvest récupère automatiquement l'indice pertinent selon votre bail." },
        { q: "La hausse du loyer est-elle plafonnée ?", a: "Oui, elle est encadrée par l'évolution de l'IRL, et des plafonnements spécifiques peuvent s'appliquer dans certaines zones ou pour les logements énergivores." },
      ]}
      related={[
        { to: "/revision-loyer-irl/calculateur", label: "Calculateur de révision IRL" },
        { to: "/quittance-de-loyer", label: "Quittance de loyer" },
        { to: "/declaration-revenus-fonciers", label: "Revenus fonciers" },
        { to: "/tarifs", label: "Voir les tarifs" },
      ]}
    />
  );
}
